import { useApiModel } from '@hooks/use-api-model';
import type { ITestDiagnosticModel } from '@/types/test-diagnostic';

const TEST_DIAGNOSTIC_ENDPOINT = '/api/register/qa/test-diagnostic';

const defaultTestDiagnosticModel: ITestDiagnosticModel = {
    registrationId: 0,
    source: '',
    referralSource: null,
    entryDomain: null,
    entryQuery: null,
    entryReferrerId: null,
    entryReferrer: null,
};

export const useTestDiagnostic = () => useApiModel(TEST_DIAGNOSTIC_ENDPOINT, defaultTestDiagnosticModel);
